import React from 'react';
import { changeState } from '@teammo/teammo-general-utils';
import { Link } from 'react-router-dom';
import _ from 'lodash';
import classnames from 'classnames';
import Phone from 'react-phone-number-input/input';
import { Input, FormFeedback } from 'reactstrap';
import Button from 'app/components/general/Button';
import IconButton from 'app/components/general/IconButton';

import CancelIcon from 'app/images/icons/cancel.svg';
import validateInput from './AddTeamMemberRowValidator';

interface IAddTeamMemberRowProps {
  currentUser: any;
  fullName: string;
  email: string;
  mobile: string;
  createTeamMember: any;
  cancelTeamMember: any;
  teamId: string;
  clubId: string;
  errors: any;
  isLoading: boolean;
}

interface IAddTeamMemberRowState {
  fullName: string;
  email: string;
  mobile: string;
  errors: any;
  changed: boolean;
}

export default class AddTeamMemberRow extends React.Component<IAddTeamMemberRowProps, IAddTeamMemberRowState> {
  static defaultProps: IAddTeamMemberRowProps = {
    fullName: undefined,
    email: undefined,
    currentUser: undefined,
    mobile: undefined,
    createTeamMember: undefined,
    cancelTeamMember: undefined,
    teamId: undefined,
    clubId: undefined,
    errors: {},
    isLoading: false,
  };

  state: IAddTeamMemberRowState = {
    fullName: this.props.fullName || '',
    email: this.props.email || '',
    mobile: this.props.mobile || '',
    errors: this.props.errors || {},
    changed: false,
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    if (!prevState.changed) {
      return {
        ...prevState,
        errors: nextProps.errors,
      };
    }
    return null;
  }

  handleMobileChange = (e) => {
    this.setState({ changed: true, errors: {}, mobile: e });
  };

  handleChange = (e) => {
    e.persist();
    this.setState((previousState) => ({
      ...changeState(previousState, e.target),
      changed: true,
      errors: {},
    }));
  };

  handleCancel = () => {
    this.props.cancelTeamMember();
  };

  handleSubmit = (e) => {
    e.preventDefault();

    if (this.isValid()) {
      this.setState({ changed: false });
      this.props.createTeamMember({
        fullName: this.state.fullName,
        email: this.state.email,
        mobile: this.state.mobile,
        team: {
          id: this.props.teamId,
        },
        club: {
          id: this.props.clubId,
        },
      });
    }
  };

  isValid() {
    const { errors, isValid } = validateInput(this.state);

    if (!isValid) {
      this.setState({ errors });
    }

    return isValid;
  }

  renderErrorFeedback = (name) => {
    if (
      this.state.errors !== undefined
      && !_.isEmpty(this.state.errors[name])
    ) {
      if (_.isArray(this.state.errors[name])) {
        return this.state.errors[name].join(', ');
      }
      return this.state.errors[name];
    }
    return null;
  };

  render() {
    const fullNameError = !_.isEmpty(this.state.errors.fullName);
    const mobileError = !_.isEmpty(this.state.errors.mobile);
    const emailError = !_.isEmpty(this.state.errors.email);

    const mobileSameAsManagerError = !_.isEmpty(this.props.currentUser)
      && this.state.mobile === this.props.currentUser.mobile;
    return (
      <form>
        <div className="row content-row add-team-member-row">
          <div className="col col-12 col-sm-3 d-sm-none">
            Add Team Member
          </div>
          <div className="col col-12 col-md-3 flex-col">
            <Input
              onChange={this.handleChange}
              name="fullName"
              placeholder="Full name"
              aria-label="Full name"
              autoFocus
              errors={this.state.errors}
              className={classnames({
                'is-invalid': fullNameError,
              })}
              value={this.state.fullName}
            />
            <FormFeedback>
              {this.renderErrorFeedback('fullName')}
            </FormFeedback>
          </div>
          <div className="col col-12 col-sm-2 flex-col">
            <Phone
              onChange={this.handleMobileChange}
              name="mobile"
              className={classnames('form-control', {
                'is-invalid': mobileError,
              })}
              country="AU"
              value={this.state.mobile}
              placeholder="Mobile"
              errors={this.state.errors}
              aria-label="Mobile"
            />
            <FormFeedback
              className={classnames({
                showing: mobileError || mobileSameAsManagerError,
              })}
            >
              {mobileSameAsManagerError && ['This number is the same as your mobile number, please see this ', <a target="_blank" href="https://help.teammo.com.au/en/articles/1603405-i-play-in-the-team-that-i-manage-how-do-i-make-my-payment">help article</a>]}
              {this.renderErrorFeedback('mobile')}
            </FormFeedback>
          </div>

          <div className="col col-12 col-sm-3 flex-col">
            <Input
              onChange={this.handleChange}
              name="email"
              value={this.state.email}
              placeholder="Email (Optional)"
              className={classnames({
                'is-invalid': emailError,
              })}
              errors={this.state.errors}
              aria-label="Email (Optional)"
            />
            <FormFeedback>
              {this.renderErrorFeedback('email')}
            </FormFeedback>
          </div>

          <div className="col col-12 col-sm-3 btn-flex-group">
            <div className="btn-flex-container thin-margin">
              <Button
                className="btn-thin btn-success"
                isLoading={this.props.isLoading}
                type="submit"
                disabled={
                  !this.state.fullName || !this.state.mobile
                }
                onClick={this.handleSubmit}
              >
                Save
              </Button>
              <IconButton
                icon={CancelIcon}
                className="cancel-icon btn btn-thin btn-2 btn-thinner-padding"
                onClick={this.handleCancel}
              />
            </div>
          </div>
        </div>
      </form>
    );
  }
}
